// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = (fn: any, time: number) => {
  let timeout: NodeJS.Timeout;
  return function () {
    // @ts-ignore
    // eslint-disable-next-line prefer-rest-params
    const functionCall = () => fn.apply(this, arguments);
    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};
